import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BenefitImage, BenefitText, BenefitWrapper } from "./subcomponents";
var Benefit = function (_a) {
    var imageUrl = _a.imageUrl, imageTitle = _a.imageTitle, children = _a.children;
    return (_jsxs(BenefitWrapper, { children: [_jsx(BenefitImage, { src: imageUrl, alt: imageTitle }), _jsx(BenefitText, { children: children })] }));
};
export default Benefit;
